export enum VendorOrderStatusEnum {
  SUCCESS = "SUCCESS",
  PARTIAL_SUCCESS = "PARTIAL_SUCCESS",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NON_API = "NON_API",
  UNPROCESSED = "UNPROCESSED"
}

export interface VendorOrderStatusBadgeStyle {
  bg: string;
  text: string;
  icon: string;
}

export const VENDOR_ORDER_STATUS_BADGE_STYLE: Record<
  VendorOrderStatusEnum,
  VendorOrderStatusBadgeStyle
> = {
  [VendorOrderStatusEnum.SUCCESS]: {
    bg: "bg-green-lp-300",
    text: "text-green-lp-400",
    icon: require("@/app/ui/assets/svg/ics_f_check_circle.svg")
  },
  [VendorOrderStatusEnum.FAILED]: {
    bg: "bg-red-lp-3100",
    text: "text-red-lp-2400",
    icon: require("@/app/ui/assets/svg/x-circle.svg")
  },
  [VendorOrderStatusEnum.PARTIAL_SUCCESS]: {
    bg: "bg-yellow-lp-200",
    text: "text-yellow-lp-100",
    icon: require("@/app/ui/assets/svg/x-circle-yellow.svg")
  },
  [VendorOrderStatusEnum.IN_PROGRESS]: {
    bg: "bg-yellow-lp-200",
    text: "text-yellow-lp-100",
    icon: require("@/app/ui/assets/svg/ics_f_clock2_orange.svg")
  },
  [VendorOrderStatusEnum.NON_API]: {
    bg: "bg-gray-lp-200",
    text: "text-black-lp-300",
    icon: require("@/app/ui/assets/svg/ics_f_close_circle.svg")
  },
  [VendorOrderStatusEnum.UNPROCESSED]: {
    bg: "bg-gray-lp-200",
    text: "text-black-lp-300",
    icon: require("@/app/ui/assets/svg/ics_f_close_circle.svg")
  }
};

export const DEFAULT_VENDOR_ORDER_STATUS_BADGE_STYLE: VendorOrderStatusBadgeStyle = {
  bg: "bg-gray-lp-200",
  text: "text-black-lp-300",
  icon: ""
};

export function resolveVendorOrderStatusEnum(
  status: string
): VendorOrderStatusEnum | null {
  if (!status) {
    return null;
  }
  const upper = status.trim().toUpperCase();
  if (
    Object.values(VendorOrderStatusEnum).includes(
      upper as VendorOrderStatusEnum
    )
  ) {
    return upper as VendorOrderStatusEnum;
  }
  return null;
}

export function getVendorOrderStatusBadgeStyle(
  status: string
): VendorOrderStatusBadgeStyle {
  const resolved = resolveVendorOrderStatusEnum(status);
  if (resolved && VENDOR_ORDER_STATUS_BADGE_STYLE[resolved]) {
    return VENDOR_ORDER_STATUS_BADGE_STYLE[resolved];
  }
  return DEFAULT_VENDOR_ORDER_STATUS_BADGE_STYLE;
}

export const INTERIM_VENDOR_ORDER_STATUS_LABELS: Record<
  VendorOrderStatusEnum,
  string
> = {
  [VendorOrderStatusEnum.SUCCESS]: "Berhasil Respon",
  [VendorOrderStatusEnum.FAILED]: "Gagal Respon",
  [VendorOrderStatusEnum.PARTIAL_SUCCESS]: "Berhasil Sebagian",
  [VendorOrderStatusEnum.UNPROCESSED]: "API Tidak tersedia",
  [VendorOrderStatusEnum.IN_PROGRESS]: "Diproses",
  [VendorOrderStatusEnum.NON_API]: "Tanpa API"
};

export function getVendorOrderStatusLabel(
  status: string,
  t?: (key: string) => string
): string {
  const resolved = resolveVendorOrderStatusEnum(status);
  if (!resolved) {
    return "—";
  }
  if (t) {
    const key = `handover.list.statusHitApi.${resolved}`;
    const translated = t(key);
    if (translated && translated !== key) {
      return translated;
    }
  }
  return INTERIM_VENDOR_ORDER_STATUS_LABELS[resolved] || "—";
}
